import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [isIos, setIsIos] = useState(false);

  useEffect(() => {
    const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (standalone || sessionStorage.getItem("dtt-install-dismissed")) return undefined;
    const ios = /iphone|ipad|ipod/i.test(window.navigator.userAgent);
    setIsIos(ios);
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    if (ios) setShow(true); // iOS never fires beforeinstallprompt — show manual instructions instead
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  if (!show) return null;

  const dismiss = () => {
    sessionStorage.setItem("dtt-install-dismissed", "1");
    setShow(false);
  };

  const install = async () => {
    if (deferred) {
      deferred.prompt();
      await deferred.userChoice;
    }
    dismiss();
  };

  return (
    <div className="fixed bottom-4 inset-x-4 z-50 sm:left-auto sm:right-4 sm:max-w-sm rounded-lg border border-border bg-white shadow-lg p-3 flex items-start gap-3"
      data-testid="install-prompt">
      <Download className="h-5 w-5 text-primary shrink-0 mt-0.5" />
      <div className="flex-1 text-sm">
        <p className="font-semibold text-slate-800">Install Deluxe Travel Training</p>
        {isIos ? (
          <p className="text-xs text-slate-600 mt-0.5">
            On your iPhone/iPad: tap the Share button, then &quot;Add to Home Screen&quot;.
          </p>
        ) : (
          <p className="text-xs text-slate-600 mt-0.5">
            Add the app to your home screen for quick, full-screen access on your phone or tablet.
          </p>
        )}
        {!isIos && deferred && (
          <Button size="sm" className="mt-2 h-8 text-xs" data-testid="install-app-button" onClick={install}>
            Install app
          </Button>
        )}
      </div>
      <button type="button" onClick={dismiss} data-testid="install-prompt-dismiss"
        className="text-slate-400 hover:text-slate-600" aria-label="Dismiss install prompt">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
